export const POPULATION_COLOR = ['#0097A9', '#ED8B00', '#86BC25', '#62B5E5', '#A497F4', '#FFA0C5', '#009A44']

export const RISK_COLOR = ['#63666A', '#005587']

export const RACE_AND_ETHNICITY = [
  {key: 'AIAN', name: 'American Indian and Alaska Native'},
  {key: 'WHITE', name: 'White'},
  {key: 'BAA', name: 'Black or African American'},
  {key: 'ASIAN', name: 'Asian'},
  {key: 'NHOPI', name: 'Native Hawaiian and Other Pacific Islander'},
  {key: 'HL', name: 'Hispanic or LatinX'},
  {key: 'MRO', name: 'Multi-Race or Other'}
]

export const GENDER = [
  {key: 'FEMALE', name: 'Female'},
  {key: 'MALE', name: 'Male'}
]

export const CHART_NAMES = {
  POPULATION: 'PopulationOverTimeChart',
  RISK: 'RiskOverTimeChart'
}

export const LINE_CHAR_LIMIT = 15 // 15 characters per line for marker label
